import { Component, HostListener, inject, OnInit } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { PrimeNGConfig } from 'primeng/api';
import { Resource } from './resources/resource';
import { WINDOW, WindowRef } from './shared/services/window.service';
import { AppResource } from './app.resource';
import { environment } from 'src/environments/environment';
import { AppInsightsService } from './shared/services/app-insight.service';
import { GtmService } from './shared/services/google-tag-manager.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
  title = 'template-parcours';
  resource: Resource;
  private windowRef = inject<WindowRef>(WINDOW);

  constructor(
    private config: PrimeNGConfig,
    private appInsightService: AppInsightsService,
    private router: Router,
    private gtmService: GtmService,
    protected resources: AppResource
  ) {
    this.resource = resources['resource'];
    this.preloadSVG();
  }

  ngOnInit(): void {

    this.config.setTranslation({
      dayNames: ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'],
      dayNamesShort: ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'],
      dayNamesMin: ['Di', 'Lu', 'Ma', 'Me', 'Je', 'Ve', 'Sa'],
      monthNames: [
        'Janvier',
        'Février',
        'Mars',
        'Avril',
        'Mai',
        'Juin',
        'Juillet',
        'Août',
        'Septembre',
        'Octobre',
        'Novembre',
        'Decembre'
      ],
      monthNamesShort: [
        'Jan',
        'Fév',
        'Mar',
        'Avr',
        'Mai',
        'Juin',
        'Juil',
        'Aou',
        'Sep',
        'Oct',
        'Nov',
        'Déc'
      ],
      dateFormat: 'dd/mm/yy',
      firstDayOfWeek: 1,
      today: "Aujourd'hui",
      weekHeader: 'Wk'
    });

    this.gtmService.init(environment.googleTagManagerId);
    this.trackPageViews();
  }

  private trackPageViews(): void {
    this.gtmService.pushEvent('page_view', {
      page_path: this.router.url,
      page_title: document.title
    });
  }

  loadScript(_url: string) {
    let node = document.createElement('script');
    node.src = _url;
    node.type = 'text/javascript';
    document.getElementsByTagName('head')[0].appendChild(node);
  }

  @HostListener('document:appInsights_allowed', ['$event'])
  onAppInsightsAllowed(ev: any) {
    this.appInsightService.initAppInsights();
  }

  @HostListener('document:appInsights_disallowed', ['$event'])
  onAppInsightsDisallowed(ev: any) {
    this.appInsightService.disableAppInsights();
  }

  preloadSVG() {
    var svgs = [this.resource.header.logo];
    var frag = new Array<Node>();

    svgs.forEach(item => {
      var res = document.createElement('link');
      res.rel = 'preload';
      res.type = 'image/svg+xml';
      res.as = 'image';
      res.href = item;
      frag.push(res);
    });

    document.getElementsByTagName('head')[0].append(...frag);
  }
}
